export const listContainerStyles = {
  gap: '4px',
};

export const listItemStyles = {
  display: 'flex',
  gap: '4px',
  justifyContent: 'space-between',
};

export const listItemLabelStyles = {
  flexShrink: 0,
};

export const listItemTextStyles = {
  textAlign: 'end',
};
